//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    rightTarget: {
      default: "",
      type: String
    },
    chooseTarget: {
      default: "",
      type: String
    },
    analysisContent: {
      default: "",
      type: String
    },
    pageKind: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      // right_target: [],
      // choose_target: [],
      // chooseStatus: false
    };
  },
  // mounted() {
  //   this.right_target = this.rightTarget.split(",").sort().toString();
  //   this.choose_target = this.chooseTarget.split(",").sort().toString();
  // }
};



// WEBPACK FOOTER //
// ./src/components/exam/chooseAnalysis.vue